import React, { useState, useRef } from 'react';
import * as S from './styles';
type StarProps = {
  filter: any;
  filterKey: string;
  setFilter: any;
  star: number;
  dataTestId?: string;
};
const Star: React.FC<StarProps> = ({
  filter,
  filterKey,
  setFilter,
  star,
  dataTestId
}) => {
  const containerRef = useRef<HTMLLIElement>();
  const [isHoved, setIsHoved] = useState<boolean>(false);
  const isStarActive = (stars: number[], star: number) => {
    return stars?.includes(star);
  };
  const handleClick = event => {
    event.preventDefault();
    if (isStarActive(filter?.[filterKey], star)) {
      setFilter(f => ({
        ...f,
        [filterKey]: filter?.[filterKey]?.filter(filterOption => filterOption !== star)
      }));
    } else {
      setFilter(f => ({
        ...f,
        [filterKey]: (filter?.[filterKey] || []).concat(star)
      }));
    }
  };
  return <S.Container isActive={isHoved || isStarActive(filter?.[filterKey], star)} onMouseEnter={() => setIsHoved(true)} onMouseLeave={() => setIsHoved(false)} onClick={handleClick} onTouchEnd={handleClick} ref={containerRef} data-testid={dataTestId}>
      {star}
      <S.StarIconFull />
    </S.Container>;
};
export default Star;